import { useMemo, useRef } from "react";
import { useSelector } from "react-redux";
import { useBootstrapTooltip } from "../../hooks/useBootstrapOverlay";
import MemberInfoButton from "./MemberInfoButton";
import {
  getDisplayGlobal,
  getMemberShiftsCount,
  getMemberHoursCount,
  hasEnoughShiftHours,
} from "../../stores/member/memberSelectors";
import { getPeriods } from "../../stores/member/memberSelectors";

const Member = ({ member }) => {
  const displayGlobal = useSelector(getDisplayGlobal);
  const periods = useSelector(getPeriods);
  const selectedMembers = useSelector(
    (state) => state.member.selected_members || []
  );

  // Memoize the selection state to avoid unnecessary re-renders
  const isSelected = useMemo(
    () => selectedMembers.includes(member.id),
    [selectedMembers, member.id]
  );


  const getPeriodName = (periodId) => {
    const period = periods.find((p) => p.id === periodId);
    return period ? period.name : "";
  };

  const hasEnough = hasEnoughShiftHours(member);
  const klass = hasEnough ? "grey" : "";

  // The check mark is the only tooltip this component owns, and it only exists when hasEnough.
  const checkMarkRef = useRef(null);
  useBootstrapTooltip(checkMarkRef, [member.id, hasEnough]);

  const leaderMark = <i className="fa fa-star"></i>;
  const requiredHoursCheckMark = (
    <i
      ref={checkMarkRef}
      className="fa fa-check"
      data-toggle="tooltip"
      data-placement="right"
      title={I18n.t("schedule.member.has_required_hours")}
    ></i>
  );

  return (
    <div
      className={`member ${isSelected ? "selected" : ""}`}
      data-member={JSON.stringify(member)}
      data-member-id={member.id}
    >
      <div className={klass}>
        <div className="member_name">
          {member.name} {member.team_leader ? leaderMark : ""}
          {hasEnough ? requiredHoursCheckMark : ""}
          <MemberInfoButton member={member} />
        </div>
        <div className="clearfix">
          <div className="member_stat">
            <span className="member_stat_label">
              {I18n.t("schedule.members.shift_count_header")}{" "}
            </span>
            <span className="member_stat_value">
              {getMemberShiftsCount(member, displayGlobal)}
            </span>
          </div>
          <div className="member_stat">
            <span className="member_stat_label">
              {I18n.t("schedule.members.hour_count_header")}{" "}
            </span>
            <span className="member_stat_value">
              {getMemberHoursCount(member, displayGlobal)}
            </span>
          </div>
          <div className="member_stat">
            <span className="member_stat_label">
              {I18n.t("schedule.members.period_header")}{" "}
            </span>
            <span className="member_stat_value">
              {member.period_id
                ? getPeriodName(member.period_id)
                : I18n.t("schedule.members.no_period")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Member;
